import React from 'react'
import './permissionCheck.scss'
import LoadingSpinner from '../loading-spinner'

interface PermissionCheckProps extends React.PropsWithChildren {
  hasPermission: boolean
  isLoading?: boolean
}

function PermissionCheck({ hasPermission, isLoading, children }: PermissionCheckProps) {
  if (isLoading) {
    return (
      <div className='permission__loader'>
        <LoadingSpinner />
      </div>
    )
  }

  if (!hasPermission) {
    return <AccessDeniedNotification />
  }

  return <>{children}</>
}

export default PermissionCheck

function AccessDeniedNotification() {
  return (
    <div className='notification__error'>
      <p>Access Denied: You do not have the required permissions</p>
    </div>
  )
}
